import apiTool from './index';

const GET_SERVICES_URL = 'services/?no_page';
const GET_CLIENT_SERVICES_URL = 'clients/<client_id>/services/?no_page';

const UPDATE_USER_SERVICE = 'clients/<pk>/users/<user_pk>/services/';
const UPDATE_CLIENT_SERVICES = 'clients/<pk>/services/';

export default {
  getServices() {
    return apiTool.get(GET_SERVICES_URL);
  },
  getClientServices(client_id) {
    return apiTool.get(
      GET_CLIENT_SERVICES_URL.replace('<client_id>', client_id)
    );
  },

  updateClientServices(payload) {
    return apiTool.put(
      UPDATE_CLIENT_SERVICES.replace('<pk>', payload.pk),
      payload.data
    );
  },
  updateUserService(payload) {
    return apiTool.put(
      UPDATE_USER_SERVICE.replace('<pk>', payload.pk).replace(
        '<user_pk>',
        payload.user_pk
      ),
      payload.data
    );
  }
};
